import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

export enum OverlayType {
  FIXED = 'fixed',
  STATIC = 'static',
}

@Component({
  selector: 'atx-loader-overlay',
  templateUrl: './loader-overlay.component.html',
  styleUrls: ['./loader-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoaderOverlayComponent {
  /**
   * Text displayed under spinner icon
   */
  @Input()
  public loaderText: string;

  @Input()
  public type: OverlayType = OverlayType.FIXED;

  @HostBinding('class.fixed')
  public get isFixed() {
    return this.type === OverlayType.FIXED;
  }

  @HostBinding('class.static')
  public get isStatic() {
    return this.type === OverlayType.STATIC;
  }
}
